import { useState, useEffect, useCallback } from 'react'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const Authenticating = () => {
  const { t } = useTranslation()
  const [showFallbackButton, setShowFallbackButton] = useState(false)

  useEffect(() => {
    // Show fallback button after 10 seconds if redirect hasn't happened
    const timer = setTimeout(() => {
      setShowFallbackButton(true)
    }, 10000)

    return () => clearTimeout(timer)
  }, [])

  const handleReturnToMain = useCallback(() => {
    window.location.href = '/'
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      textAlign="center"
      sx={{ p: 3 }}
    >
      <CircularProgress size={60} sx={{ mb: 3, color: 'primary.main' }} />
      
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
        Authenticating...
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        You are being redirected to the login page. Please wait...
      </Typography>

      {showFallbackButton && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Taking longer than expected?
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleReturnToMain}
            size="large"
          >
            {t('ReturnToChat') || 'Return to Chat'}
          </Button>
        </Box>
      )}
    </Box>
  )
}
